import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { sparklesIcon } from '@progress/kendo-svg-icons';
import { AgentNote } from '.';

export default function AIBillToInstructionsCell(
  openInstructions: (dataItem: AgentNote) => void
) {
  return class extends React.Component<GridCustomCellProps> {
    render() {
      const dataItem = this.props.dataItem as AgentNote;
      const hasInstructions = dataItem.HasBillToDeterminationInstructions;
      const title = hasInstructions ? 'Edit AI Bill-To instructions' : 'Add AI Bill-To instructions';

      return (
        <td
          {...this.props.tdProps}
          style={{ ...this.props.tdProps?.style, textAlign: 'center' }}
        >
          <Button
            title={title}
            aria-label={title}
            disabled={!dataItem.ID}
            fillMode={hasInstructions ? 'solid' : 'outline'}
            themeColor={hasInstructions ? 'primary' : undefined}
            svgIcon={sparklesIcon}
            onClick={() => openInstructions(dataItem)}
          />
        </td>
      );
    }
  }
}
